module.exports = __webpack_public_path__ + "img/statistics.6de91319.png";